import React from 'react'
import Table from '../../Wrappers/Table'
import PayrollProcessRow from './Rows/PayrollProcessRow'

const PayrollProcessesTable = () => {
  // Procesos de pruebas
  const processes = [
    {
      id: '234',
      name: 'Nómina quincenal del 1 al 15',
      type: 'Nómina',
      employees: ['Juan', 'María', 'Sergio', 'Joel', 'Rosa', 'Athenea', 'Margarito'],
      status: 'Activo',
      steps: ['Novedades', 'Prenómina', 'Pagos'],
      current: 'PAYSLIPS',
      isFinished: false,
    },
    {
      id: '235',
      name: 'Liquidación de contraro Fulanito Martínez',
      type: 'Liquidación',
      employees: ['Fulanito'],
      status: 'Cerrado',
      steps: ['Novedades', 'Prenómina', 'Pagos'],
      current: 'PAYMENTS',
      isFinished: true,
    },
    {
      id: '236',
      name: 'Liquidación de Mangano Pérez, Jorge Cruz y Margarito.',
      type: 'Nómina',
      employees: ['Mangano', 'Jorge', 'Margarito'],
      status: 'Activo',
      steps: ['Novedades', 'Prenómina', 'Pagos'],
      current: 'NOVELTIES',
      isFinished: false,
    },
  ]

  return (
    <div className="main">
      <Table heads={['Id', 'Nombre', 'Tipo', 'Empleados', 'Estado', 'Paso actual']}>
        {processes.map(process => (
          <PayrollProcessRow process={process} />
        ))}
      </Table>
    </div>
  )
}

export default PayrollProcessesTable
